module.exports = __webpack_public_path__ + "img/about3.875c37c7.png";